/** @jsx jsx */
import { jsx } from "theme-ui"
import { useStaticQuery, graphql } from "gatsby"
import Modal from "./modal"
import Form from "./form"

const NewsletterForm = ({ onClose }) => {
  const data = useStaticQuery(graphql`
    query newsletterFormQuery {
      contentfulSection(slug: { eq: "page-section-footer-contact-form" }) {
        content {
          internal {
            content
          }
        }
      }
    }
  `)
  const formData = JSON.parse(data.contentfulSection.content.internal.content)
  if (formData.detailField)
    formData.defaultFields = {
      ...formData.defaultFields,
      [formData.detailField]: `Newsletter Signup`,
    }
  return (
    <Modal
      customStyle={{ maxWidth: [null, null, null, 700], boxSizing: 'border-box' }}
      onClose={onClose}
    >
      <Form formData={formData} noSteps={true} type="secondary"></Form>
    </Modal>
  )
}

export default NewsletterForm
